export default "__VITE_ASSET__DChuPs0t__"